import { IContentFromEPG } from '~/src/dash/api/demand-settings/epg/epg_models';
import { createUrl, restGet, restPatch } from '~/src/dash/api/rest';

export async function getEPGContentTogglesForPublisher(
  publisherID: string,
): Promise<[IContentFromEPG[] | undefined, Error | undefined]> {
  const reqUrl = createUrl('/publishers/' + publisherID + '/content_from_epg', publisherID);

  try {
    return [(await restGet<IContentFromEPG[]>(reqUrl)).parsedBody, undefined];
  } catch (e) {
    return [undefined, e];
  }
}

export async function updateEPGContentTogglesForPublisher(
  publisherID: string,
  contents: IContentFromEPG[],
): Promise<[IContentFromEPG[] | undefined, Error | undefined]> {
  const reqUrl = createUrl('/publishers/' + publisherID + '/content_from_epg', publisherID);

  try {
    return [(await restPatch<IContentFromEPG[]>(reqUrl, contents)).parsedBody, undefined];
  } catch (e) {
    return [undefined, e];
  }
}
